/**
 * InventoryItemsPage Component
 *
 * Page wrapper for the Inventory Items management functionality.
 * Renders the InventoryItemsList component with page header.
 *
 * User Story: US-P6-001 - Inventory Management
 * Step 2: Inventory Items Management
 */

import { PageLayout } from '@/components/layout'
import InventoryItemsList from '@/components/inventory/InventoryItemsList'

export default function InventoryItemsPage({ user, onLogout }) {
  return (
    <PageLayout user={user} onLogout={onLogout}>
      <div className="space-y-6">
        {/* Page Header */}
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">Inventory Items</h1>
          <p className="text-sm text-slate-600 mt-1">
            Manage your inventory materials, packaging, and supplies.
          </p>
        </div>

        {/* Inventory Items List */}
        <InventoryItemsList />
      </div>
    </PageLayout>
  )
}
